import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import App from "./components/App";
import Loadable from "react-loadable";
import Loading from "./components/helpers/loading";
import React from "react";
import ReactDOM from "react-dom";
import Root from "./Root";
import withTracker from "./withTracker";
import SingleStoreRouter from "./components/Mobile/SingleStoreRouter";
import RouteChangeHandler from "./components/helpers/RouteChangeHandler";
import AutoBrandLoader from "./components/Mobile/AutoBrandLoader";
import RootBrandRoute from "./components/Mobile/RootBrandRoute";
import BrandSlugRedirect from "./components/Mobile/BrandSlugRedirect";

const CloneOffers = Loadable({
	loader: () => import("./components/Mobile/Clones/Offers"),
	loading: () => <Loading />,
});

// import NotFound from "./components/NotFound";
const NotFound = Loadable({
	loader: () => import("./components/NotFound"),
	loading: () => <Loading />,
});

// import Location from "./components/Mobile/Location";
const Location = Loadable({
	loader: () => import("./components/Mobile/Location"),
	loading: () => <Loading />,
});

const Home = Loadable({
	loader: () => import("./components/Mobile/Home"),
	loading: () => <Loading />,
});

// import Items from "./components/Mobile/Items";
// const Items = Loadable({
// 	loader: () => import("./components/Mobile/Items"),
// 	loading: () => <Loading />,
// });

// import Login from "./components/Mobile/Auth/Login";
const Login = Loadable({
	loader: () => import("./components/Mobile/Auth"),
	loading: () => <Loading />,
});

// import Register from "./components/Mobile/Auth/Register";
const Register = Loadable({
	loader: () => import("./components/Mobile/Auth/Register"),
	loading: () => <Loading />,
});

// import CartPage from "./components/Mobile/Cart";
const CartPage = Loadable({
	loader: () => import("./components/Mobile/Cart"),
	loading: () => <Loading />,
});

// import Coupons from "./components/Mobile/Cart/Coupons";
const Coupons = Loadable({
	loader: () => import("./components/Mobile/Cart/Coupons"),
	loading: () => <Loading />,
});

// import ApplyCoupon from "./components/Mobile/Cart/ApplyCoupon";
const ApplyCoupon = Loadable({
	loader: () => import("./components/Mobile/Cart/ApplyCoupon"),
	loading: () => <Loading />,
});

// import Account from "./components/Mobile/Account";
const Account = Loadable({
	loader: () => import("./components/Mobile/Account"),
	loading: () => <Loading />,
});

const UpdateProfile = Loadable({
	loader: () => import("./components/Mobile/Account/UpdateProfile"),
	loading: () => <Loading />,
});

// import Explore from "./components/Mobile/Explore";
const Explore = Loadable({
	loader: () => import("./components/Mobile/Explore"),
	loading: () => <Loading />,
});

// import Addresses from "./components/Mobile/Account/Addresses";
const Addresses = Loadable({
	loader: () => import("./components/Mobile/Account/Addresses"),
	loading: () => <Loading />,
});

// import Checkout from "./components/Mobile/Checkout";
const Checkout = Loadable({
	loader: () => import("./components/Mobile/Checkout"),
	loading: () => <Loading />,
});

// import RunningOrder from "./components/Mobile/RunningOrder";
const RunningOrder = Loadable({
	loader: () => import("./components/Mobile/RunningOrder"),
	loading: () => <Loading />,
});

// import VerifyPayment from "./components/Mobile/Checkout/PaymentList/VerifyPayment";
const VerifyPayment = Loadable({
	loader: () => import("./components/Mobile/Checkout/PaymentList/VerifyPayment"),
	loading: () => <Loading />,
});


// import Orders from "./components/Mobile/Account/Orders";
const Orders = Loadable({
	loader: () => import("./components/Mobile/Account/Orders"),
	loading: () => <Loading />,
});

// import WalletPage from "./components/Mobile/Account/Wallet";
const WalletPage = Loadable({
	loader: () => import("./components/Mobile/Account/Wallet"),
	loading: () => <Loading />,
});
/* Delivery */
// import Delivery from "./components/Delivery";
const Delivery = Loadable({
	loader: () => import("./components/Delivery"),
	loading: () => <Loading />,
});

// import DeliveryLogin from "./components/Delivery/Login";
const DeliveryLogin = Loadable({
	loader: () => import("./components/Delivery/Login"),
	loading: () => <Loading />,
});

// import DeliveryOrders from "./components/Delivery/Orders";
const DeliveryOrders = Loadable({
	loader: () => import("./components/Delivery/Orders"),
	loading: () => <Loading />,
});

// import ViewOrder from "./components/Delivery/ViewOrder";
const ViewOrder = Loadable({
	loader: () => import("./components/Delivery/ViewOrder"),
	loading: () => <Loading />,
});

// import GeoLocationPage from "./components/Mobile/GeoLocationPage";
const GeoLocationPage = Loadable({
	loader: () => import("./components/Mobile/GeoLocationPage"),
	loading: () => <Loading />,
});

// import SingleItem from "./components/Mobile/Items/SingleItem";
// const SingleItem = Loadable({
// 	loader: () => import("./components/Mobile/Items/SingleItem"),
// 	loading: () => <Loading />,
// });

const ItemsByCategory = Loadable({
	loader: () => import("./components/Mobile/Items/ItemsByCategory"),
	loading: () => <Loading />,
});

const ItemsParent = Loadable({
	loader: () => import("./components/Mobile/Items/ItemsParent"),
	loading: () => <Loading />,
});

const SingleItemParent = Loadable({
	loader: () => import("./components/Mobile/Items/SingleItemParent"),
	loading: () => <Loading />,
});

const SinglePage = Loadable({
	loader: () => import("./components/SinglePage"),
	loading: () => <Loading />,
});

const ForgotPassword = Loadable({
	loader: () => import("./components/Mobile/Auth/ForgotPassword"),
	loading: () => <Loading />,
});

const Test = Loadable({
	loader: () => import("./components/Mobile/Test"),
	loading: () => <Loading />,
});

const RestaurantListOnCategory = Loadable({
	loader: () => import("./components/Mobile/Home/RestaurantListOnCategory"),
	loading: () => <Loading />,
});

const RatingAndReview = Loadable({
	loader: () => import("./components/Mobile/Account/Orders/RatingAndReview"),
	loading: () => <Loading />,
});
const ViewStoreReviews = Loadable({
	loader: () => import("./components/Mobile/StoreReviews"),
	loading: () => <Loading />,
});

const Alerts = Loadable({
	loader: () => import("./components/Mobile/Alerts"),
	loading: () => <Loading />,
});

const Offers = Loadable({
	loader: () => import("./components/Mobile/Offers"),
	loading: () => <Loading />,
});

const FavoriteRestaurantList = Loadable({
	loader: () => import("./components/Mobile/Home/FavoriteRestaurants"),
	loading: () => <Loading />,
});

const LoginAsCustomer = Loadable({
	loader: () => import("./components/Mobile/Modules/LoginAsCustomer"),
	loading: () => <Loading />,
});

const PickupAndDrop = Loadable({
	loader: () => import("./components/Mobile/PickupAndDrop"),
	loading: () => <Loading />,
});
const Task = Loadable({
	loader: () => import("./components/Mobile/PickupAndDrop/Task"),
	loading: () => <Loading />,
});
const PickupDropDetails = Loadable({
	loader: () => import("./components/Mobile/PickupAndDrop/Details"),
	loading: () => <Loading />,
});
const PickupAndDropCart = Loadable({
	loader: () => import("./components/Mobile/PickupAndDrop/PickupAndDropCart"),
	loading: () => <Loading />,
});
const PickupAndDropCheckout = Loadable({
	loader: () => import("./components/Mobile/PickupAndDrop/PickupAndDropCheckout"),
	loading: () => <Loading />,
});
const PickupDropSearchLocation = Loadable({
	loader: () => import("./components/Mobile/PickupAndDrop/SearchLocation"),
	loading: () => <Loading />,
});
const SelectLocationPage = Loadable({
	loader: () => import("./components/Mobile/PickupAndDrop/SelectLocationPage"),
	loading: () => <Loading />,
});
const PickupSearchLocation = Loadable({
	loader: () => import("./components/Mobile/PickupAndDrop/SearchLocation"),
	loading: () => <Loading />,
});

// Brand Location Selector
const BrandLocationSelector = Loadable({
	loader: () => import("./components/Mobile/BrandLocationSelector"),
	loading: () => <Loading />,
});

const ScrollToTop = () => {
	window.scrollTo(0, 0);
	return null;
};

/**
 * Helper function to wrap brand-scoped route render functions
 * Redirects to root when singleBrandForDomain exists
 */
const brandScopedRouteRender = (renderFn) => {
	return (props) => {
		const singleBrand = localStorage.getItem('singleBrandForDomain');
		// If single brand exists and the brand slug matches, redirect to root
		if (singleBrand && props.match.params.brandSlug === singleBrand) {
			const pathWithoutBrand = props.location.pathname.replace(`/${props.match.params.brandSlug}`, '') || '/';
			const search = props.location.search || '';
			const hash = props.location.hash || '';
			return <Redirect to={pathWithoutBrand + search + hash} />;
		}
		// Otherwise, call the original render function
		return renderFn(props);
	};
};

ReactDOM.render(
	<Root>
		<BrowserRouter forceRefresh={false}>
			<Route render={({ location }) => (
			<RouteChangeHandler key={location.pathname}>
			<SingleStoreRouter>
				<React.Fragment>
					<Route component={ScrollToTop} />
				<Switch key={location.pathname}>
				{/* <Route exact strict  path="/:url*" render={props => <Redirect to={`${props.location.pathname}/`} />} /> */}
				
			{/* Root route - Auto-load brand if only one exists, otherwise show selection */}
			<Route path={"/"} exact render={(props) => {
				// Use AutoBrandLoader to check and load single brand at root
				return <AutoBrandLoader {...props} key={props.location.pathname} />;
			}} />
			
			
			{/* Root-level routes - Work from / when single brand exists for domain */}
			<RootBrandRoute path={"/fresh-meat"} exact component={withTracker(Home)} />
			<RootBrandRoute path={"/clones/offers"} exact component={CloneOffers} />
			<RootBrandRoute path={"/search-location"} exact component={withTracker(Location)} />
			<RootBrandRoute path={"/my-location"} exact component={withTracker(GeoLocationPage)} />
			<RootBrandRoute path={"/categories/stores"} exact component={withTracker(RestaurantListOnCategory)} />
			<RootBrandRoute path={"/store/:restaurant/category/:categoryId"} exact component={withTracker(ItemsByCategory)} />
			<RootBrandRoute path={"/stores/:restaurant"} exact component={withTracker(ItemsParent)} />
			<RootBrandRoute path={"/stores/:restaurant/:id"} exact component={withTracker(SingleItemParent)} />
			<RootBrandRoute path={"/explore"} exact component={withTracker(Explore)} />
			<RootBrandRoute path={"/new-test"} exact component={withTracker(Test)} />
			<RootBrandRoute path={"/login"} exact component={withTracker(Login)} />
			<RootBrandRoute path={"/login/forgot-password"} exact component={withTracker(ForgotPassword)} />
			<RootBrandRoute path={"/register"} exact component={withTracker(Register)} />
			<RootBrandRoute path={"/my-account"} exact component={withTracker(Account)} />
			<RootBrandRoute path={"/alerts"} exact component={withTracker(Alerts)} />
			<RootBrandRoute path={"/offers"} exact component={withTracker(Offers)} />
			<RootBrandRoute path={"/my-addresses"} exact component={withTracker(Addresses)} />
			<RootBrandRoute path={"/my-wallet"} exact component={withTracker(WalletPage)} />
			<RootBrandRoute path={"/my-orders"} exact component={withTracker(Orders)} />
			<RootBrandRoute path={"/rate-order/:id"} exact component={withTracker(RatingAndReview)} />
			<RootBrandRoute path={"/reviews/:slug"} exact component={withTracker(ViewStoreReviews)} />
			<RootBrandRoute path={"/update-profile"} exact component={withTracker(UpdateProfile)} />
			<RootBrandRoute path={"/checkout"} exact component={withTracker(Checkout)} />
			<RootBrandRoute path={"/running-order/:unique_order_id"} exact component={withTracker(RunningOrder)} />
			<RootBrandRoute path={"/payu-verify/:transaction_id"} exact component={withTracker(VerifyPayment)} />
			<RootBrandRoute path={"/cart"} exact component={withTracker(CartPage)} />
			<RootBrandRoute path={"/cart/coupons"} exact component={withTracker(Coupons)} />
			<RootBrandRoute path={"/cart/apply-coupon"} exact component={withTracker(ApplyCoupon)} />
			<RootBrandRoute path={"/pages/:slug"} exact component={withTracker(SinglePage)} />
			<RootBrandRoute path={"/my-favorite-stores"} exact component={withTracker(FavoriteRestaurantList)} />
			<RootBrandRoute path={"/select-location"} exact component={withTracker(BrandLocationSelector)} />
			<RootBrandRoute path={"/pickup-and-drop"} exact component={withTracker(PickupAndDrop)} />
			<RootBrandRoute path={"/pickup-and-drop/task"} exact component={withTracker(Task)} />
			<RootBrandRoute path={"/pickup-and-drop/search-location"} exact component={withTracker(PickupSearchLocation)} />
			<RootBrandRoute path={"/pickup-and-drop/details"} exact component={withTracker(PickupDropDetails)} />
			<RootBrandRoute path={"/pickup-and-drop/cart"} exact component={withTracker(PickupAndDropCart)} />
			<RootBrandRoute path={"/pickup-and-drop/checkout"} exact component={withTracker(PickupAndDropCheckout)} />
			<RootBrandRoute path={"/pickup-and-drop/location-search/:address_type"} exact component={withTracker(PickupDropSearchLocation)} />
			<RootBrandRoute path={"/pickup-and-drop/select-location/:address_type"} exact component={withTracker(SelectLocationPage)} />
			<RootBrandRoute path={"/delivery"} exact component={Delivery} />
			<RootBrandRoute path={"/delivery/login"} exact component={DeliveryLogin} />
			<RootBrandRoute path={"/delivery/orders"} exact component={DeliveryOrders} />
			<RootBrandRoute path={"/delivery/orders/:unique_order_id"} exact component={ViewOrder} />
			<RootBrandRoute path={"/delivery/completed-orders"} exact component={Delivery} />
			<RootBrandRoute path={"/auth/login-as-customer/:id?"} exact component={withTracker(LoginAsCustomer)} />
				
				{/* Brand-scoped routes - All routes under /:brandSlug */}
				{/* These routes redirect to root when singleBrandForDomain exists */}
				<Route path={"/:brandSlug"} exact render={(props) => {
					const singleBrand = localStorage.getItem('singleBrandForDomain');
					if (singleBrand && props.match.params.brandSlug === singleBrand) {
						return <Redirect to="/" />;
					}
					return <App {...props} key={props.location.pathname} />;
				}} />
					<Route path={"/:brandSlug/fresh-meat"} exact render={brandScopedRouteRender((props) => {const TrackedHome = withTracker(Home); return <TrackedHome {...props} key={props.location.pathname} />;})} />
					
					<Route path={"/:brandSlug/clones/offers"} exact render={brandScopedRouteRender((props) => <CloneOffers {...props} key={props.location.pathname} />)} />
					
					<Route path={"/:brandSlug/search-location"} exact render={(props) => {const TrackedLocation = withTracker(Location); return <TrackedLocation {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/my-location"} exact render={(props) => {const TrackedGeoLocation = withTracker(GeoLocationPage); return <TrackedGeoLocation {...props} key={props.location.pathname} />;}} />
					
					<Route path={"/:brandSlug/categories/stores"} exact render={(props) => {const TrackedRestaurantListOnCategory = withTracker(RestaurantListOnCategory); return <TrackedRestaurantListOnCategory {...props} key={props.location.pathname} />;}} />
					
					<Route path={"/:brandSlug/store/:restaurant/category/:categoryId"} exact render={(props) => {const TrackedItemsByCategory = withTracker(ItemsByCategory); return <TrackedItemsByCategory {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/stores/:restaurant"} exact render={(props) => {const TrackedItemsParent = withTracker(ItemsParent); return <TrackedItemsParent {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/stores/:restaurant/:id"} exact render={(props) => {const TrackedSingleItemParent = withTracker(SingleItemParent); return <TrackedSingleItemParent {...props} key={props.location.pathname} />;}} />
					
					<Route path={"/:brandSlug/explore"} exact render={(props) => {const TrackedExplore = withTracker(Explore); return <TrackedExplore {...props} key={props.location.pathname} />;}} />
					
					<Route path={"/:brandSlug/new-test"} exact render={(props) => {const TrackedTest = withTracker(Test); return <TrackedTest {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/login"} exact render={(props) => {const TrackedLogin = withTracker(Login); return <TrackedLogin {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/login/forgot-password"} exact render={(props) => {const TrackedForgotPassword = withTracker(ForgotPassword); return <TrackedForgotPassword {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/register"} exact render={(props) => {const TrackedRegister = withTracker(Register); return <TrackedRegister {...props} key={props.location.pathname} />;}} />
					
					<Route path={"/:brandSlug/my-account"} exact render={(props) => {const TrackedAccount = withTracker(Account); return <TrackedAccount {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/alerts"} exact render={(props) => {const TrackedAlerts = withTracker(Alerts); return <TrackedAlerts {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/offers"} exact render={(props) => {const TrackedOffers = withTracker(Offers); return <TrackedOffers {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/my-addresses"} exact render={(props) => {const TrackedAddresses = withTracker(Addresses); return <TrackedAddresses {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/my-wallet"} exact render={(props) => {const TrackedWalletPage = withTracker(WalletPage); return <TrackedWalletPage {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/my-orders"} exact render={(props) => {const TrackedOrders = withTracker(Orders); return <TrackedOrders {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/rate-order/:id"} exact render={(props) => {const TrackedRatingAndReview = withTracker(RatingAndReview); return <TrackedRatingAndReview {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/reviews/:slug"} exact render={(props) => {const TrackedViewStoreReviews = withTracker(ViewStoreReviews); return <TrackedViewStoreReviews {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/update-profile"} exact render={(props) => {const TrackedUpdateProfile = withTracker(UpdateProfile); return <TrackedUpdateProfile {...props} key={props.location.pathname} />;}} />
					
					<Route path={"/:brandSlug/checkout"} exact render={(props) => {const TrackedCheckout = withTracker(Checkout); return <TrackedCheckout {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/running-order/:unique_order_id"} exact render={(props) => {const TrackedRunningOrder = withTracker(RunningOrder); return <TrackedRunningOrder {...props} key={props.location.pathname} />;}} />
					
					<Route path={"/:brandSlug/payu-verify/:transaction_id"} exact render={(props) => {const TrackedVerifyPayment = withTracker(VerifyPayment); return <TrackedVerifyPayment {...props} key={props.location.pathname} />;}} />
					
					<Route path={"/:brandSlug/cart"} exact render={(props) => {const TrackedCartPage = withTracker(CartPage); return <TrackedCartPage {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/cart/coupons"} exact render={(props) => {const TrackedCoupons = withTracker(Coupons); return <TrackedCoupons {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/cart/apply-coupon"} exact render={(props) => {const TrackedApplyCoupon = withTracker(ApplyCoupon); return <TrackedApplyCoupon {...props} key={props.location.pathname} />;}} />
					
					<Route path={"/:brandSlug/pages/:slug"} exact render={(props) => {const TrackedSinglePage = withTracker(SinglePage); return <TrackedSinglePage {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/my-favorite-stores"} exact render={(props) => {const TrackedFavoriteRestaurantList = withTracker(FavoriteRestaurantList); return <TrackedFavoriteRestaurantList {...props} key={props.location.pathname} />;}} />
					
					{/* Brand Location Selector Route */}
					<Route path={"/:brandSlug/select-location"} exact render={(props) => {const TrackedBrandLocationSelector = withTracker(BrandLocationSelector); return <TrackedBrandLocationSelector {...props} key={props.location.pathname} />;}} />
					
					{/* Pickup and Drop Routes */}
					<Route path={"/:brandSlug/pickup-and-drop"} exact render={(props) => {const TrackedPickupAndDrop = withTracker(PickupAndDrop); return <TrackedPickupAndDrop {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/pickup-and-drop/task"} exact render={(props) => {const TrackedTask = withTracker(Task); return <TrackedTask {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/pickup-and-drop/search-location"} exact render={(props) => {const TrackedPickupSearchLocation = withTracker(PickupSearchLocation); return <TrackedPickupSearchLocation {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/pickup-and-drop/details"} exact render={(props) => {const TrackedPickupDropDetails = withTracker(PickupDropDetails); return <TrackedPickupDropDetails {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/pickup-and-drop/cart"} exact render={(props) => {const TrackedPickupAndDropCart = withTracker(PickupAndDropCart); return <TrackedPickupAndDropCart {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/pickup-and-drop/checkout"} exact render={(props) => {const TrackedPickupAndDropCheckout = withTracker(PickupAndDropCheckout); return <TrackedPickupAndDropCheckout {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/pickup-and-drop/location-search/:address_type"} exact render={(props) => {const TrackedPickupDropSearchLocation2 = withTracker(PickupDropSearchLocation); return <TrackedPickupDropSearchLocation2 {...props} key={props.location.pathname} />;}} />
					<Route path={"/:brandSlug/pickup-and-drop/select-location/:address_type"} exact render={(props) => {const TrackedSelectLocationPage = withTracker(SelectLocationPage); return <TrackedSelectLocationPage {...props} key={props.location.pathname} />;}} />
					
					{/* Delivery Routes */}
					<Route path={"/:brandSlug/delivery"} exact render={(props) => <Delivery {...props} key={props.location.pathname} />} />
					<Route path={"/:brandSlug/delivery/login"} exact render={(props) => <DeliveryLogin {...props} key={props.location.pathname} />} />
					<Route path={"/:brandSlug/delivery/orders"} exact render={(props) => <DeliveryOrders {...props} key={props.location.pathname} />} />
					<Route path={"/:brandSlug/delivery/orders/:unique_order_id"} exact render={(props) => <ViewOrder {...props} key={props.location.pathname} />} />
					<Route path={"/:brandSlug/delivery/completed-orders"} exact render={(props) => <Delivery {...props} key={props.location.pathname} />} />
					
					{/* Admin Login as Customer Module Routes */}
					<Route path={"/:brandSlug/auth/login-as-customer/:id?"} exact render={(props) => {const TrackedLoginAsCustomer = withTracker(LoginAsCustomer); return <TrackedLoginAsCustomer {...props} key={props.location.pathname} />;}} />
					
					<Route component={NotFound} />
				</Switch>
			</React.Fragment>
			</SingleStoreRouter>
			</RouteChangeHandler>
			)} />
		</BrowserRouter>
	</Root>,
	document.getElementById("root")
);